// import af from "./translations/af";
// import ar from "./translations/ar";
// import bg from "./translations/bg";
// import bs from "./translations/bs";
// import ca from "./translations/ca";
// import cs from "./translations/cs";
// import da from "./translations/da";
// import de from "./translations/de";
// import ee from "./translations/ee";
// import el from "./translations/el";
import en from "./translations/en";
// import es from "./translations/es";
// import fa from "./translations/fa";
// import fi from "./translations/fi";
// import fo from "./translations/fo";
import fr from "./translations/fr";
// import ge from "./translations/ge";
// import gl from "./translations/gl";
// import he from "./translations/he";
// import hr from "./translations/hr";
// import hu from "./translations/hu";
// import id from "./translations/id";
// import is from "./translations/is";
// import it from "./translations/it";
// import ja from "./translations/ja";
// import kk from "./translations/kk";
// import ko from "./translations/ko";
// import lb from "./translations/lb";
// import lt from "./translations/lt";
// import lv from "./translations/lv";
// import mk from "./translations/mk";
// import mn from "./translations/mn";
// import nbNO from "./translations/nb-NO";
// import nl from "./translations/nl";
// import pl from "./translations/pl";
// import ptBR from "./translations/pt-BR";
// import ro from "./translations/ro";
// import ru from "./translations/ru";
// import sk from "./translations/sk";
// import slSI from "./translations/sl-SI";
// import srCYRL from "./translations/sr-CYRL";
// import sr from "./translations/sr";
// import sv from "./translations/sv";
// import th from "./translations/th";
// import tr from "./translations/tr";
// import uk from "./translations/uk";
// import ur from "./translations/ur";
// import vi from "./translations/vi";
// import zh from "./translations/zh";
// import zhHK from "./translations/zh-HK";

export default {
	en, fr
	// af,
	// ar,
	// bg,
	// bs,
	// ca,
	// cs,
	// da,
	// de,
	// ee,
	// el,
	// en,
	// es,
	// fa,
	// fi,
	// fo,
	// fr,
	// ge,
	// gl,
	// he,
	// hr,
	// hu,
	// id,
	// is,
	// it,
	// ja,
	// kk,
	// ko,
	// lb,
	// lt,
	// lv,
	// mk,
	// mn,
	// nbNO,
	// nl,
	// pl,
	// ptBR,
	// ro,
	// ru,
	// sk,
	// slSI,
	// srCYRL,
	// sr,
	// sv,
	// th,
	// tr,
	// uk,
	// ur,
	// vi,
	// zh,
	// zhHK
	// eslint-disable-next-line
};
